
import { SiteHeader } from './components/SiteHeader';
import { HeroSection } from './sections/HeroSection';
import { OverviewSection } from './sections/OverviewSection';
import { WhatArkIsSection } from './sections/WhatArkIsSection';
import { CapabilitiesSection } from './sections/CapabilitiesSection';
import { UseCasesSection } from './sections/UseCasesSection';
import { CompetitiveSection } from './sections/CompetitiveSection';
import { SecuritySection } from './sections/SecuritySection';
import { ConnectorsSection } from './sections/ConnectorsSection';
import { FinalCTASection } from './sections/FinalCTASection';
import { SiteFooter } from './components/SiteFooter';
import { StickyCTAs } from './components/StickyCTAs';

function App() {
  return (
    <div className="ark-page min-h-screen flex flex-col">
      <SiteHeader />
      <main className="flex-1">
        <HeroSection />
        <OverviewSection />
        <WhatArkIsSection />
        <CapabilitiesSection />
        <UseCasesSection />
        <CompetitiveSection />
        <SecuritySection />
        <ConnectorsSection />
        <FinalCTASection />
      </main>
      <SiteFooter />
      <StickyCTAs />
    </div>
  );
}

export default App;
